import { pdf } from "@react-pdf/renderer";
import React from "react";
import { TreatmentPlanResponse } from "../services/treatmentPlanService";
import SummarizedTreatmentPlanPdf from "../components/SummarizedTreatmentPlanPdf/SummarizedTreatmentPlanPdf";

const createPdf = (element: React.ReactElement): ReturnType<typeof pdf> =>
  pdf(element);

const formatDate = (d: string) =>
  new Date(d).toLocaleDateString("en-US", {
    month: "2-digit",
    day: "2-digit",
    year: "numeric",
  });

interface DownloadSummarizedPdfParams {
  treatmentPlan: TreatmentPlanResponse;
  content: string;
  clinicName?: string;
  clinicEmail?: string;
  clinicPhone?: string;
  clinicWebsite?: string;
}

export const downloadSummarizedTreatmentPlanPdf = async ({
  treatmentPlan,
  content,
  clinicName,
  clinicEmail,
  clinicPhone,
  clinicWebsite,
}: DownloadSummarizedPdfParams): Promise<void> => {
  const patientName =
    [treatmentPlan.patientFirstName, treatmentPlan.patientLastName]
      .filter(Boolean)
      .join("_") || "Patient";

  const pdfDocument = React.createElement(SummarizedTreatmentPlanPdf, {
    treatmentPlan,
    content,
    clinicName,
    clinicEmail,
    clinicPhone,
    clinicWebsite,
  });

  const blob = await createPdf(pdfDocument).toBlob();
  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.download = `TreatmentPlanSummary_${patientName}_${formatDate(treatmentPlan.dateGenerated).replace(/\//g, "-")}.pdf`;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
};
